// ترجماتُ المجموعة 9 — تُملأ بترجمة صفحاتها (2026-10-03). المفتاح: النصُّ العربيّ كما في tt().
const EN_B9: Record<string, string> = {
  "خروجية": "Out (non-rental)",
  "مبيوعة": "Sold",
  "وقت الخروج": "Out time",
  "الوجهة": "Destination",
  "🎥 فيديو السيارة": "🎥 Car video",
  "📷 صورة العداد": "📷 Odometer photo",
  "🏷️ ستيكر السيرفس": "🏷️ Service sticker",
  "📄 أوراق العقد": "📄 Contract papers",
  "بانتظار الاعتماد": "Awaiting approval",
  "جارٍ الإرسال": "Sending",
  "معتمَد": "Approved",
  "مرفوض": "Rejected",
  "أُرجع للتعديل": "Returned for edits",
  "هذه السيّارة بلا عقدٍ سارٍ في برنامج التأجير — ابحث برقم العقد.": "This car has no active contract in the rental system — search by contract number.",
  "إعدادات الشركة ناقصة: اضبط «هويّة الشركة» من الإعدادات ← هويّة الشركة، ثمّ أعد البحث.": "Company settings are incomplete: set \"Company identity\" under Settings → Company identity, then search again.",
  "فرعُ هذه السيّارة غيرُ محلول في المزامنة — راجع الإدارة.": "This car's branch is not resolved in the sync — contact the administration.",
  "تعذّر إنشاء صفّ العقد — راجع الإدارة.": "Couldn't create the contract record — contact the administration.",
  "لا يوجد صفُّ عقدٍ لهذه النتيجة — راجع الإدارة.": "No contract record for this result — contact the administration.",
  "بدأ": "Started",
  "مُقفل": "Closed",
  "تعذّر الحفظ": "Couldn't save",
  "السائق الآخر": "Second driver",
  "عمولة التوصيل على هذه الرفعة": "Delivery commission on this upload",
  "رفعه": "Uploaded by",
  "رفضه": "Rejected by",
  "اعتمده": "Approved by",
  "سبب الرفض:": "Rejection reason:",
  "أُرجعت": "Returned",
  "قبل ذلك": "before",
  "عمولة الرافع ملغاة": "Uploader's commission voided",
  "وعمولة {name} تُصرف": "{name}'s commission is still paid",
  "بلا مرافق": "No companion",
  "السائق الآخر:": "Second driver:",
  "سبب إلغاء عمولة التوصيل (يصل الموظّف):": "Reason for voiding the delivery commission (sent to the employee):",
  "اكتب السبب — الموظّف لا يتعلّم من عقوبةٍ بلا سبب": "Enter a reason — an employee can't learn from a penalty without one",
  "تعذّر الإلغاء": "Couldn't void",
  "أُلغيت عمولة التوصيل وأُبلغ الموظّف": "Delivery commission voided and the employee notified",
  "سبب الرفض (يراه الموظّف):": "Rejection reason (visible to the employee):",
  "ما الذي يجب تصحيحه؟ (يراه الموظّف):": "What needs to be corrected? (visible to the employee):",
  "اكتب سبب الإرجاع": "Enter the reason for returning",
  "اعتماد وإرسال للعميل؟": "Approve and send to the customer?",
  "الإرسال من:": "Send from:",
  "تلقائي": "Automatic",
  "تعذّر التنفيذ": "Couldn't complete the action",
  "اعتُمد وأُرسل للعميل": "Approved and sent to the customer",
  "أُرجع للموظّف للتعديل": "Returned to the employee for edits",
  "رُفض": "Rejected",
  "فشل التحميل": "Failed to load",
  "فشل المزامنة": "Sync failed",
  "بدأت المزامنة": "Sync started",
  "تعمل بالخلفية — حدّث الصفحة بعد دقيقة": "Running in the background — refresh the page in a minute",
  "لا نتائج": "No results",
  "لم يُعثر على عقد بهذا الرقم": "No contract found with this number",
  "لا يمكن الإرسال": "Can't send",
  "فشل رفع {name}": "Failed to upload {name}",
  "الملفّ أكبر من الحدّ ({n} ميغا)": "File exceeds the limit ({n} MB)",
  "خطأ ({n})": "Error ({n})",
  "حُفظت وتنتظر الاعتماد": "Saved and awaiting approval",
  "لم يصل العميلَ شيء بعد — يعتمدها موظّف التأجير ثم تُرسَل.": "Nothing has reached the customer yet — a rental employee approves it, then it's sent.",
  "تعذّر الإرسال عبر واتساب": "Couldn't send via WhatsApp",
  "الاستبيان:": "Survey:",
  "لم يُرسل": "not sent",
  "التقرير/الفيديو: وصل {n} من {m}": "Report/video: {n} of {m} delivered",
  "حُفظت الملفات — لكنها لم تصل العميل": "Files saved — but they didn't reach the customer",
  "تم الإرسال للعميل": "Sent to the customer",
  "تم إرسال استبيان الرضا": "Satisfaction survey sent",
  "التقرير والفيديو أُرسلا للعميل عبر واتساب": "The report and video were sent to the customer via WhatsApp",
  "الاستبيان أُرسل": "Survey sent",
  "ومعه {n} ملف": "with {n} file(s)",
  "بيانات مزامَنة من برنامج التأجير": "Data synced from the rental system",
  "جاري المزامنة...": "Syncing…",
  "مزامنة": "Sync",
  "بلا فيديو": "No video",
  "بانتظار اعتمادك": "Awaiting your approval",
  "سجل الفيديوهات": "Video log",
  "فيديو الاستلام": "Return video",
  "فيديو التأجير": "Rental video",
  "ابحث برقم اللوحة، العميل، أو رقم العقد…": "Search by plate, customer, or contract number…",
  "من أصل": "of",
  "السائق:": "Driver:",
  "رقم الليسن": "License number",
  "شهري:": "Monthly:",
  "عداد التأجير:": "Rental odometer:",
  "عداد الاستلام:": "Return odometer:",
  "فيديو التأجير — إرسال للعميل": "Rental video — send to customer",
  "فيديو الاستلام — إرسال استبيان الرضا": "Return video — send satisfaction survey",
  "تم إرسال الفيديو للعميل": "Video sent to the customer",
  "الفيديو أُرسل عبر واتساب للعميل المسجل بالعقد": "The video was sent via WhatsApp to the customer on the contract",
  "رسالة تقييم الخدمة (1-5) أُرسلت للعميل عبر واتساب": "The service rating message (1-5) was sent to the customer via WhatsApp",
  "ادخل رقم العقد...": "Enter contract number…",
  "اختر العقد": "Choose the contract",
  "لا يُرسَل عليه": "Can't send on this",
  "لا يمكن إرسال فيديو على هذا العقد": "A video can't be sent on this contract",
  "لا يوجد رقم واتساب لهذا العميل": "This customer has no WhatsApp number",
  "الفيديو لن يصله. أضف رقمه في ملفّ العميل ثم أعد اختيار العقد — أو أكمل للتوثيق الداخليّ فقط.": "The video won't reach them. Add their number to the customer profile, then re-select the contract — or continue for internal records only.",
  "رفع صور وفيديوهات": "Upload photos and videos",
  "{n} ملف محدد": "{n} file(s) selected",
  "اضغط لإضافة المزيد": "Click to add more",
  "اضغط لاختيار صور أو فيديوهات": "Click to choose photos or videos",
  "يمكن اختيار عدة ملفات — حتى {n}MB للملف": "You can choose multiple files — up to {n}MB per file",
  "عقود بلا فيديو استلام/تسليم": "Contracts without a return/handover video",
  "كل العقود الحديثة عليها فيديو": "All recent contracts have a video",
  "بلا فيديو تأجير": "No rental video",
  "بلا فيديو استلام": "No return video",
  "رفع": "Upload",
  "سجل الفيديوهات المرفوعة": "Uploaded videos log",
  "بحث برقم العقد، اللوحة، السيارة، اسم المستأجر، أو اسم الموظف...": "Search by contract number, plate, car, renter name, or employee name…",
  "فيديوهات بانتظار اعتمادك": "Videos awaiting your approval",
  "استلام": "Return",
  "تأجير": "Rental",
  "موقع الرفع": "Upload location",
  "السائق الآخر — له نفس العمولة": "Second driver — same commission",
  "اعتماد وإرسال": "Approve & send",
  "يعود للموظّف ليصحّح المرفقات أو رقم العقد — بلا إعادة تصوير": "Goes back to the employee to fix the attachments or contract number — no reshoot",
  "إرجاع للتعديل": "Return for edits",
  "رفض": "Reject",
  "تسقط عمولةُ التوصيل ويصل الموظّفَ السبب — والفيديو يمضي للعميل كما هو": "The delivery commission is dropped and the employee gets the reason — the video still goes to the customer",
  "إلغاء عمولة التوصيل": "Void delivery commission",
  "لا توجد فيديوهات مرفوعة بعد": "No videos uploaded yet",
  "تسليم السيارة": "Car handover",
  "ملف": "File",
  "لم يُرفع بعد": "Not uploaded yet",
  "الموظف:": "Employee:",
  "استلام السيارة": "Car return",
  "استبيان": "Survey",
  "المقبوضات السنوية — آخر ١٢ سنة (د.ك)": "Annual receipts — last 12 years (KWD)",
  "المصروفات السنوية — آخر ١٢ سنة (د.ك)": "Annual expenses — last 12 years (KWD)",
  "المقبوض": "Received",
  "المصروف": "Spent",
  "السنة": "Year",
  "النموّ عن السنة السابقة": "Growth vs previous year",
  "حتى اليوم": "to date",
  "سند": "voucher(s)",
  "سند ليموزين": "limousine voucher(s)",
  "طبيعي": "Normal",
  "قرب الميزانية": "Near budget",
  "تجاوز الميزانية": "Over budget",
  "غير مصنف": "Uncategorized",
  "حُفظ": "Saved",
  "دمج {n} تصنيف في «{name}»؟ (دمج على مستوى العرض عندنا — Drive8 لا يتأثر)": "Merge {n} categories into \"{name}\"? (Display-level merge on our side — Drive8 is not affected)",
  "التصنيف": "Category",
  "الفاتورة": "Invoice",
  "بقية التصنيفات": "Other categories",
  "غير مجمّع": "Ungrouped",
  "لا تملك صلاحية عرض هذه الصفحة.": "You don't have permission to view this page.",
  "من نظام التأجير (Drive8) — الصرف من السندات، والقبض من مقبوضات العقود والليموزين": "From the rental system (Drive8) — expenses from vouchers, receipts from contract and limousine payments",
  "تصدير CSV": "Export CSV",
  "آخر ٩٠ يوم": "Last 90 days",
  "هذه السنة": "This year",
  "بحث بالسندات: سيارة / عقد / اسم / فاتورة... (Enter)": "Search vouchers: car / contract / name / invoice… (Enter)",
  "🔻 الصرف": "🔻 Expenses",
  "🟢 القبض": "🟢 Receipts",
  "⚖️ المقارنة — ربح/خسارة": "⚖️ Comparison — profit/loss",
  "{n}٪ عن الفترة السابقة": "{n}% vs previous period",
  "سندات القبض (مطابق لتقرير Drive8)": "Receipt vouchers (matches Drive8 report)",
  "مقبوض الليموزين (سندات، ضمن القبض)": "Limousine receipts (vouchers, included in receipts)",
  "متوسط السند": "Average voucher",
  "طرق الدفع": "Payment methods",
  "المقبوضات الشهرية — آخر ١٢ شهراً (د.ك)": "Monthly receipts — last 12 months (KWD)",
  "أعلى العملاء قبضاً (الفترة)": "Top paying customers (period)",
  "تفصيل طرق الدفع (الفترة)": "Payment methods breakdown (period)",
  "سندات القبض": "Receipt vouchers",
  "رقم السند": "Voucher no.",
  "تفاصيل": "Details",
  "لا توجد سندات قبض مطابقة": "No matching receipt vouchers",
  "يُعرض أحدث 500 سند — ضيّق النطاق (الإجماليات أعلاه تشمل كل النتائج)": "Showing the latest 500 vouchers — narrow the range (totals above include all results)",
  "القبض هنا من سندات القبض الفعلية بتواريخ دفعها الحقيقية (متزامنة من Drive8 كل ٥ دقائق) — يطابق تقرير «قائمة سندات القبض» في Drive8. مقبوض الليموزين يُحتسب بتاريخ المشوار.": "Receipts here come from actual receipt vouchers on their real payment dates (synced from Drive8 every 5 minutes) — matching the \"Receipt vouchers list\" report in Drive8. Limousine receipts are counted by trip date.",
  "إجمالي القبض (د.ك)": "Total receipts (KWD)",
  "إجمالي الصرف (د.ك)": "Total expenses (KWD)",
  "سندات صرف": "Payment vouchers",
  "أقساط تمويل سيارات": "Car finance installments",
  "أقساط تمويل (ERP)": "Finance installments (ERP)",
  "ربحان": "Profit",
  "خسران": "Loss",
  "الصافي (قبض − صرف) بالدينار": "Net (receipts − expenses) in KWD",
  "الهامش {n}٪": "Margin {n}%",
  "تحسّن": "Improved",
  "{n} د.ك عن الفترة السابقة": "{n} KWD vs previous period",
  "أقساط تمويل متأخرة غير مدفوعة:": "Overdue unpaid finance installments:",
  "قسط": "installment(s)",
  "أقساط مستحقة ضمن الفترة (غير مدفوعة بعد):": "Installments due in the period (not yet paid):",
  "إجمالي المتبقي على كل معاملات التمويل:": "Total remaining on all finance deals:",
  "المتبقي لكل شركة تمويل": "Remaining per finance company",
  "جدول الأقساط غير المدفوعة القادمة ({n} قسط — يُعرض أقرب {m})": "Upcoming unpaid installments ({n} installments — showing the nearest {m})",
  "الاستحقاق": "Due date",
  "شركة التمويل": "Finance company",
  "البنك / الشيك": "Bank / cheque",
  "متأخر": "Overdue",
  "قادم": "Upcoming",
  "قبض مقابل صرف — آخر ١٢ شهراً (الأعمدة = الصافي)": "Receipts vs expenses — last 12 months (bars = net)",
  "القبض": "Receipts",
  "الصرف (شامل الأقساط)": "Expenses (incl. installments)",
  "قراءة Jisr AI للربحية": "Jisr AI profitability reading",
  "جارٍ التحليل...": "Analyzing…",
  "حدّث": "Refresh",
  "حلّل ربحيتي": "Analyze my profitability",
  "يحلل: رابح أم خاسر وكم، أي الشهور خسرت وليش، وماذا تفعل.": "Analyzes: profit or loss and by how much, which months lost and why, and what to do.",
  "الشهر": "Month",
  "سندات الصرف": "Payment vouchers",
  "أقساط التمويل": "Finance installments",
  "أقساط (ERP)": "Installments (ERP)",
  "ربح": "Profit",
  "خسارة": "Loss",
  "مقارنة تدفق نقدي تشغيلي: القبض من سندات القبض الفعلية بتواريخها + الليموزين، والصرف = سندات الصرف + أقساط تمويل السيارات (كل قسط بشهر استحقاقه من معاملات التمويل) + أقساط التمويل بقاعدة الفاصل الزمني: حتى 31/12/2025 من جدول Drive8 (المدفوع فقط)، ومن 1/1/2026 حصرياً من قيود ERP حساب «شركات تمويل بالأقساط 2201001» بتاريخ القيد — فلا يُحتسب أي قسط مرتين. تُستثنى القيود الافتتاحية (أرصدة مرحّلة وليست مصروف الشهر). ليست قائمة دخل محاسبية كاملة (لا تشمل استهلاك الأصول).": "Operating cash-flow comparison: receipts from actual receipt vouchers on their dates + limousine; expenses = payment vouchers + car finance installments (each installment in its due month from finance deals) + finance installments under a cut-off rule: until 31/12/2025 from the Drive8 table (paid only), and from 1/1/2026 exclusively from ERP entries on the \"Installment finance companies 2201001\" account by entry date — so no installment is counted twice. Opening entries are excluded (carried-forward balances, not the month's expense). This is not a full accounting income statement (it excludes asset depreciation).",
  "إجمالي المصاريف": "Total expenses",
  "عدد السندات": "Number of vouchers",
  "أكبر تصنيف": "Largest category",
  "الأعلى نمواً": "Fastest growing",
  "غير مصنف / أخرى": "Uncategorized / other",
  "{n}٪ من الإجمالي": "{n}% of total",
  "تصنيفات متشابهة يُقترح دمجها": "Similar categories suggested for merging",
  "الدمج على مستوى العرض في جسر فقط — بيانات Drive8 الأصلية لا تتغير، وتقدر تفكه من درج التصنيف.": "The merge is display-only in Jisr — the original Drive8 data doesn't change, and you can undo it from the category drawer.",
  "لا توجد اقتراحات حالياً": "No suggestions right now",
  "ادمجها": "Merge them",
  "توزيع المصاريف — اضغط شريحة للتفاصيل": "Expense distribution — click a slice for details",
  "الاتجاه الشهري — آخر ١٢ شهراً (د.ك)": "Monthly trend — last 12 months (KWD)",
  "قراءة Jisr AI المالية": "Jisr AI financial reading",
  "حلّل الفترة": "Analyze the period",
  "يقرأ Jisr AI أرقام الفترة المعروضة ويكتب توصيات عملية: أين النمو غير الطبيعي، أي ميزانية انكسرت، وماذا تفعل.": "Jisr AI reads the figures for the displayed period and writes practical recommendations: where growth is abnormal, which budget was exceeded, and what to do.",
  "التصنيفات حسب المجموعة": "Categories by group",
  "كل التصنيفات ({n})": "All categories ({n})",
  "أعلى ١٠ تصنيفات": "Top 10 categories",
  "تجميع": "Group",
  "أعلى ١٠ فقط": "Top 10 only",
  "عرض كل التصنيفات": "Show all categories",
  "تصنيف": "categories",
  "السندات": "Vouchers",
  "مصفّى على تصنيف #{n}": "Filtered by category #{n}",
  "نوع {n}": "Type {n}",
  "لا توجد سندات مطابقة": "No matching vouchers",
  "{n}٪ من الفترة": "{n}% of the period",
  "٪": "%",
  "يشمل المدموجة:": "Includes merged:",
  "الميزانية الشهرية:": "Monthly budget:",
  "آخر ١٢ شهراً": "Last 12 months",
  "إعدادات محلية (ما تلمس Drive8)": "Local settings (don't touch Drive8)",
  "المجموعة الأم": "Parent group",
  "مثال: صيانة السيارات": "e.g. Car maintenance",
  "ميزانية شهرية (د.ك)": "Monthly budget (KWD)",
  "أعلى السيارات صرفاً (الفترة)": "Top spending cars (period)",
  "أعلى الأسماء (مورّد/موظف)": "Top names (supplier/employee)",
  "عرض كل سندات هذا التصنيف في الجدول": "Show all vouchers of this category in the table",
  "مدموج": "merged",
  "لا توجد بيانات في هذه الفترة": "No data in this period",
  "على رأس العمل": "On duty",
  "ذكر": "Male",
  "أنثى": "Female",
  "سارية": "Valid",
  "منتهية": "Expired",
  "بيانات الموظفين الكاملة من نظام ERP — شخصية، وظيفية، رواتب، إقامة/جواز، رخصة، تأمين": "Full employee data from the ERP — personal, job, salaries, residency/passport, license, insurance",
  "آخر مزامنة:": "Last sync:",
  "جاري المزامنة…": "Syncing…",
  "تعيد قراءة كل الموظفين — استخدمها لو تغيّرت الحالة في ERP (مثل الإجازة) وما ظهرت": "Re-reads all employees — use it if a status changed in the ERP (e.g. leave) and didn't show up",
  "مزامنة كاملة": "Full sync",
  "المزامنة تلقائية كل ساعة (وكاملة ليلاً) — أو اضغط «مزامنة من ERP» للتحديث الفوري.": "Sync runs automatically every hour (full sync nightly) — or click \"Sync from ERP\" to update now.",
  "إجمالي الموظفين": "Total employees",
  "بحث بالاسم / الرقم الوظيفي / المدني / الهاتف / الإقامة...": "Search by name / employee no. / civil ID / phone / residency…",
  "كل الشركات / المشاريع": "All companies / projects",
  "لا يوجد موظفون مطابقون": "No matching employees",
  "معفى من الحضور": "Exempt from attendance",
  "الراتب:": "Salary:",
  "مدني:": "Civil ID:",
  "الجنسية:": "Nationality:",
  "التعيين:": "Hired:",
  "الإقامة تنتهي:": "Residency expires:",
  "بيانات شخصية": "Personal details",
  "الاسم (إنجليزي)": "Name (English)",
  "الجنس": "Gender",
  "الرقم الوطني": "National ID",
  "بيانات وظيفية": "Job details",
  "الرقم الوظيفي": "Employee no.",
  "الوظيفة": "Job title",
  "القسم": "Department",
  "مكان العمل": "Workplace",
  "المدير المباشر": "Direct manager",
  "تاريخ التعيين": "Hire date",
  "تاريخ المغادرة": "Departure date",
  "نهاية الخدمة": "End of service",
  "سبب نهاية الخدمة": "End-of-service reason",
  "الراتب والبدلات": "Salary & allowances",
  "الراتب": "Salary",
  "طريقة الصرف": "Payment method",
  "حساب الصرف": "Payment account",
  "بدل اجتماعي": "Social allowance",
  "بدل تأمين": "Insurance allowance",
  "بدل مؤهل": "Qualification allowance",
  "مكافأة": "Bonus",
  "راتب إضافي": "Extra salary",
  "إجمالي الإضافي": "Total overtime",
  "الإجازات ونهاية الخدمة": "Leave & end of service",
  "آخر إجازة سنوية": "Last annual leave",
  "العودة المتوقعة": "Expected return",
  "آخر عودة": "Last return",
  "الإجازة السابقة": "Previous leave",
  "نهاية الإجازة المستحقة": "Due leave end",
  "آخر إجازة طارئة": "Last emergency leave",
  "آخر يوم عمل": "Last working day",
  "آخر عملية حساب": "Last calculation",
  "رصيد الإجازات": "Leave balance",
  "قيمة رصيد الإجازات": "Leave balance value",
  "أيام نهاية الخدمة": "End-of-service days",
  "قيمة نهاية الخدمة": "End-of-service value",
  "الإقامة والجواز": "Residency & passport",
  "رقم الإقامة": "Residency no.",
  "نوع الإقامة": "Residency type",
  "حالة الإقامة": "Residency status",
  "إصدار الإقامة": "Residency issued",
  "انتهاء الإقامة": "Residency expiry",
  "نوع الجواز": "Passport type",
  "جنسية الجواز": "Passport nationality",
  "حالة الجواز": "Passport status",
  "إصدار الجواز": "Passport issued",
  "انتهاء الجواز": "Passport expiry",
  "الرخصة": "License",
  "نوع الرخصة": "License type",
  "إصدار الرخصة": "License issued",
  "رخصة قيادة من": "Driving license from",
  "رخصة قيادة إلى": "Driving license to",
  "التأمين": "Insurance",
  "شركة التأمين": "Insurance company",
  "نوع التأمين": "Insurance type",
  "التأمين من": "Insurance from",
  "التأمين إلى": "Insurance to",
  "انتهاء البطاقة الصحية": "Health card expiry",
  "ملاحظات:": "Notes:",
  "يُعرض أول 1000 موظف — استخدم البحث لتضييق النتائج.": "Showing the first 1000 employees — use search to narrow the results.",
  "معتمد": "Approved",
  "{h}س {m}د": "{h}h {m}m",
  "لا يوجد ملف حضور لهذا الموظف — شغّل «مزامنة من ERP» لإنشائه تلقائياً.": "This employee has no attendance profile — run \"Sync from ERP\" to create it automatically.",
  "تم حفظ إعدادات الحضور": "Attendance settings saved",
  "الرقم السري للموظف «{name}» — يدخل به تطبيق الحضور بكوده ({code}):": "PIN for employee \"{name}\" — used to sign in to the attendance app with code ({code}):",
  "الرقم السري 4 خانات على الأقل": "The PIN must be at least 4 digits",
  "تم تعيين الرقم السري": "PIN set",
  "تعذّر تعيين الرقم السري": "Couldn't set the PIN",
  "إعدادات الحضور والبصمة": "Attendance & check-in settings",
  "دخول التطبيق بالكود": "App sign-in with code",
  "+ رقم سري": "+ PIN",
  "رقم سري معيّن": "PIN set",
  "بدون رقم سري": "No PIN",
  "تغيير الرقم السري": "Change PIN",
  "تعيين رقم سري": "Set PIN",
  "معفى من الحضور (عمل خارجي/ميداني — لا يُحتسب غياب ولا خصومات)": "Exempt from attendance (external/field work — no absences or deductions counted)",
  "يبصم من أي مكان (مندوب متنقّل — لا يُرفض خارج نطاق الفرع)": "Can check in from anywhere (mobile rep — not rejected outside the branch zone)",
  "الفرع (نطاق GPS)": "Branch (GPS zone)",
  "بدون": "None",
  "نوع الوردية": "Shift type",
  "8 ساعات": "8 hours",
  "12 ساعة": "12 hours",
  "مخصص": "Custom",
  "بداية الدوام": "Shift start",
  "ساعات الوردية": "Shift hours",
  "أيام العمل المطلوبة": "Required working days",
  "مكافأة شهرية": "Monthly bonus",
  "سعر الساعة الإضافية": "Overtime hourly rate",
  "سجل الحضور (آخر 60 يوم)": "Attendance log (last 60 days)",
  "ليس لديك صلاحية الاطلاع على بيانات الموظفين الآخرين — اطلب من مدير النظام منحك «حضور الموظفين الآخرين».": "You don't have permission to view other employees' data — ask the system admin to grant you \"Other employees' attendance\".",
  "لا توجد سجلات حضور": "No attendance records",
  "ساعات": "Hours",
  "{n}د": "{n}m",
  "جاري تحميل بنود الراتب…": "Loading salary items…",
  "بنود الراتب": "Salary items",
  "البند": "Item",
  "بند {n}": "Item {n}",
  "الشيكات الصادرة": "Issued Cheques",
  "مواعيد سحب الشيكات وتنبيه المدير والمشرف قبلها": "Cheque cash-out dates, with alerts to the manager and supervisor beforehand",
  "شيك جديد": "New cheque",
  "استيراد إكسل": "Import Excel",
  "إعداد التنبيه": "Alert settings",
  "مؤجلة": "Post-dated",
  "تُسحب خلال ٣٠ يوماً": "Due within 30 days",
  "فات موعدها ولم تُحدَّث": "Past due, not updated",
  "مؤجلة وتاريخها مضى — حدّث حالتها إلى «تم الصرف» أو «مرتجع»": "Post-dated with a past date — update its status to \"Cleared\" or \"Bounced\"",
  "بلا تاريخ": "No date",
  "معروضة": "Showing",
  "بحث بالجهة أو رقم الشيك أو الغرض…": "Search by payee, cheque number, or purpose…",
  "الجهة المستفيدة": "Payee",
  "الغرض": "Purpose",
  "لا توجد شيكات": "No cheques",
  "غداً": "Tomorrow",
  "بعد {n} يوم": "In {n} days",
  "مضى {n} يوم": "{n} days ago",
  "حذف هذا الشيك نهائياً؟": "Permanently delete this cheque?",
  "هذا الشيك جزء من سلسلة. موافق = حذف السلسلة كاملة، إلغاء = هذا الشيك فقط": "This cheque is part of a series. OK = delete the whole series, Cancel = this cheque only",
  "شيك واحد": "Single cheque",
  "شيكات شهرية": "Monthly cheques",
  "تاريخ أول شيك": "First cheque date",
  "عدد الشيكات (أشهر)": "Number of cheques (months)",
  "رقم أول شيك": "First cheque number",
  "مبلغ آخر شيك (إن اختلف)": "Last cheque amount (if different)",
  "مبلغ كل شيك": "Amount per cheque",
  "المبلغ الإجمالي": "Total amount",
  "لكل شيك": "Per cheque",
  "توليد الشيكات": "Generate cheques",
  "كل شيك في نفس يوم الشهر التالي، وأرقام الشيكات تتسلسل. عدّل أي سطر قبل الحفظ.": "Each cheque falls on the same day of the following month, and cheque numbers run in sequence. Edit any row before saving.",
  "المجموع": "Total",
  "حفظ {n} شيك": "Save {n} cheques",
  "اختر ملف الإكسل (.xlsx)": "Choose the Excel file (.xlsx)",
  "جارٍ قراءة الملف…": "Reading the file…",
  "سيُضاف": "Will be added",
  "موجود مسبقاً": "Already exists",
  "تاريخ لا يُقرأ — يُضاف بلا تاريخ، عدّله بعدها": "Unreadable date — added without a date, edit it afterwards",
  "رقم شيك مكرّر في نفس الحساب": "Duplicate cheque number in the same account",
  "مؤجلة وتاريخها مضى": "Post-dated with a past date",
  "حالة غير معروفة — تُضاف «مؤجل»": "Unknown status — added as \"Post-dated\"",
  "استيراد {n} شيك": "Import {n} cheques",
  "تم استيراد {n} شيك": "{n} cheques imported",
  "تنبيه واتساب مفعّل": "WhatsApp alert enabled",
  "نبّهني قبل السحب بـ": "Alert me before cash-out by",
  "يوم السحب": "Cash-out day",
  "يوم آخر": "Other day",
  "وقت الإرسال (توقيت الكويت)": "Send time (Kuwait time)",
  "يصل التنبيه للمدير والمشرف على واتساب وفي إشعارات جسر — رسالة واحدة تجمع الشيكات.": "The alert reaches the manager and supervisor on WhatsApp and in Jisr notifications — one message covering all cheques.",
  "أرسل الآن": "Send now",
  "أُرسل تنبيه عن {n} شيك": "Alert sent for {n} cheques",
  "لا شيكات تستحق تنبيهاً الآن (أو أُرسل تنبيهها سابقاً)": "No cheques need an alert right now (or their alert was already sent)",
  "تعذّر الحذف": "Couldn't delete",
  "تعذّر التوليد": "Couldn't generate",
  "تعذّر الاستيراد": "Couldn't import",
  "فارغ": "empty",
  "تعذّر الإرسال": "Couldn't send",
  "الرد الأول": "First response",
  "الحل": "Resolution",
  "المتابعة": "Follow-up",
  "العميل / المحادثة": "Customer / conversation",
  "المستوى": "Level",
  "سياسة SLA": "SLA policy",
  "⚡ رد سريع": "⚡ Fast response",
  "رد سريع": "Fast response",
  "📞 قياسي": "📞 Standard",
  "قياسي": "Standard",
  "🕘 حسب الدوام": "🕘 Business hours",
  "حسب الدوام": "Business hours",
  "🌙 خارج الدوام مرن": "🌙 Flexible after-hours",
  "خارج الدوام": "After hours",
  "القناة": "Channel",
  "{n} د": "{n} min",
  "تعطيل": "Disable",
  "اتفاقية مستوى الخدمة (SLA)": "Service Level Agreement (SLA)",
  "تعديل سياسة": "Edit policy",
  "سياسة جديدة": "New policy",
  "قوالب جاهزة:": "Presets:",
  "اسم السياسة": "Policy name",
  "وقت الرد الأول (دقائق)": "First response time (minutes)",
  "وقت الحل (دقائق، 0=معطّل)": "Resolution time (minutes, 0 = off)",
  "دوام من": "Working hours from",
  "حفظ التعديل": "Save changes",
  "إضافة سياسة": "Add policy",
  "السياسات": "Policies",
  "لا توجد سياسات": "No policies",
  "سلّم التصعيد": "Escalation ladder",
  "التصعيد تلقائي حسب مقدار التأخر عن وقت الرد الأول للسياسة — لا يحتاج أي إعداد.": "Escalation is automatic based on how late the reply is versus the policy's first-response time — no setup needed.",
  "تجاوز أول": "First breach",
  "إشعار الموظف المسؤول عن المحادثة": "Notify the agent assigned to the conversation",
  "×2 المدة": "×2 the time",
  "إشعار المشرفين": "Notify supervisors",
  "×3 المدة": "×3 the time",
  "إشعار المدراء": "Notify managers",
  "كل مستوى يُرسل إشعارًا واحدًا فقط (بدون إزعاج متكرر)، ويُعاد التسليح تلقائيًا عند الالتزام.": "Each level sends only one notification (no repeated noise), and re-arms automatically once the SLA is met.",
  "أحدث تجاوزات SLA": "Latest SLA breaches",
  "لا توجد تجاوزات": "No breaches",
  "قنوات المراسلة": "Messaging channels",
  "الأنشطة": "Businesses",
  "المستخدمون": "Users",
  "توكن AI (هذا الشهر)": "AI tokens (this month)",
  "ممنوع": "Not allowed",
  "هذه الميزة غير مشمولة بباقتك.": "This feature isn't included in your plan.",
  "وصلت الحد الأقصى — رقِّ باقتك للمزيد.": "Limit reached — upgrade your plan for more.",
  "تعذّر جلب بيانات الاشتراك": "Couldn't load subscription data",
  "تم إرسال طلب الترقية إلى «{name}» ✅ سيتواصل معك الفريق.": "Upgrade request to \"{name}\" sent ✅ The team will contact you.",
  "تعذّر إرسال الطلب": "Couldn't send the request",
  "تعذّر بدء الدفع": "Couldn't start the payment",
  "باقتك الحالية": "Your current plan",
  "لا توجد باقة مفعّلة": "No active plan",
  "السعر الشهري:": "Monthly price:",
  "الحالة:": "Status:",
  "الاشتراك حتى:": "Subscribed until:",
  "تنتهي خلال {n} يوم": "Expires in {n} days",
  "بلا تاريخ انتهاء — لا تجديد مستحق": "No expiry date — no renewal due",
  "تجديد اشتراك باقة «{name}»": "Renewal of the \"{name}\" plan",
  "آخر موعد للسداد {date}": "Payment deadline {date}",
  "خلال {n} يوم": "in {n} days",
  "انقضت المهلة": "deadline passed",
  "، وبعده يُوقف الحساب تلقائياً.": "; after that the account is suspended automatically.",
  "صدرت فاتورة التجديد — سيصلك الإشعار على الواتساب والبريد.": "The renewal invoice has been issued — you'll be notified on WhatsApp and email.",
  "جدّد وادفع الآن": "Renew & pay now",
  "الباقات المتاحة": "Available plans",
  "باقتك": "Your plan",
  "جارٍ التحويل للدفع…": "Redirecting to payment…",
  "جارٍ الإرسال…": "Sending…",
  "جدّد الاشتراك ({price} د.ك · 30 يوماً)": "Renew subscription ({price} KWD · 30 days)",
  "ادفع وفعّل": "Pay & activate",
  "اطلب الترقية": "Request upgrade",
  "أو اطلب الترقية يدوياً": "Or request the upgrade manually",
  "لا توجد باقات متاحة حاليًا.": "No plans available right now.",
  "شروط الخدمة": "Terms of Service",
  "آخر تحديث: سبتمبر 2026": "Last updated: September 2026",
  "تحكم شروط الخدمة هذه استخدامك لنظام Jisr CRM («النظام»، «نحن»)، وهو منصّة لإدارة علاقات العملاء تتيح للشركات إدارة محادثات العملاء عبر واتساب وإنستغرام وتيك توك من مكان واحد. باستخدامك للنظام فإنك توافق على هذه الشروط.": "These Terms of Service govern your use of Jisr CRM (\"the System\", \"we\"), a customer relationship management platform that lets businesses manage customer conversations across WhatsApp, Instagram, and TikTok from one place. By using the System, you agree to these terms.",
  "يشغّل النظام": "The System is operated by",
  "شركه كواد انتلكت لمواد وانظمه واجهزه الاتصالات (ذ.م.م)": "Quad Intellect Communications Materials, Systems & Devices Co. (W.L.L.)",
  "، سجل تجاري رقم 474312، وعنوانها: حولي، قطعة 1، شارع ابن خلدون، مبنى لؤلؤة بن خلدون، الدور م1، محل 37 — الكويت.": ", Commercial Registration No. 474312, located at: Hawalli, Block 1, Ibn Khaldoun Street, Lulu'at Bin Khaldoun Building, Mezzanine 1, Shop 37 — Kuwait.",
  "استخدام الخدمة": "Use of the Service",
  "تستخدم النظام لأغراض مشروعة فقط ووفقاً للأنظمة المعمول بها.": "You use the System for lawful purposes only and in accordance with applicable regulations.",
  "تلتزم بسياسات المنصّات المتكاملة (Meta وTikTok) عند إرسال واستقبال الرسائل.": "You comply with the policies of the integrated platforms (Meta and TikTok) when sending and receiving messages.",
  "أنت مسؤول عن سرية بيانات حسابك وعن نشاط المستخدمين التابعين لك.": "You are responsible for keeping your account credentials confidential and for the activity of your users.",
  "الحسابات والمحتوى": "Accounts and Content",
  "تحتفظ بملكية بيانات عملائك ومحتوى محادثاتك. نقوم بمعالجة هذه البيانات لتشغيل الخدمة فقط، وفق ما هو موضّح في سياسة الخصوصية.": "You retain ownership of your customer data and conversation content. We process this data only to operate the service, as described in the Privacy Policy.",
  "القيود": "Restrictions",
  "عدم استخدام النظام لإرسال رسائل غير مرغوب فيها (Spam) أو محتوى مخالف.": "Do not use the System to send unsolicited messages (spam) or prohibited content.",
  "عدم محاولة الوصول غير المصرّح به للنظام أو بيانات الآخرين.": "Do not attempt unauthorized access to the System or to others' data.",
  "عدم إساءة استخدام واجهات برمجة التطبيقات أو تجاوز الحدود التشغيلية.": "Do not misuse the APIs or exceed operational limits.",
  "إخلاء المسؤولية": "Disclaimer",
  "تُقدَّم الخدمة «كما هي» دون ضمانات صريحة أو ضمنية. لا نتحمّل المسؤولية عن أي أضرار غير مباشرة ناتجة عن استخدام النظام أو انقطاع خدمات الطرف الثالث.": "The service is provided \"as is\" without express or implied warranties. We are not liable for any indirect damages resulting from use of the System or from third-party service outages.",
  "إنهاء الخدمة": "Termination",
  "يجوز لنا تعليق أو إنهاء الوصول للنظام عند مخالفة هذه الشروط، مع إشعار معقول حيثما أمكن.": "We may suspend or terminate access to the System if these terms are violated, with reasonable notice where possible.",
  "التواصل معنا": "Contact Us",
  "لأي استفسار يتعلق بشروط الخدمة، يرجى التواصل عبر البريد الإلكتروني:": "For any questions about these Terms of Service, please contact us by email:",
  "تأكيد الحجز": "Booking confirmed",
  "السائق في الطريق": "Driver on the way",
  "وصل السائق": "Driver arrived",
  "الرحلة جارية": "Trip in progress",
  "الوصول": "Arrival",
  "تعذّر تحميل الرحلة": "Couldn't load the trip",
  "الرابط غير متاح": "Link unavailable",
  "جاري تحميل الرحلة…": "Loading trip…",
  "موقع السيارة غير متاح لحظياً — سيظهر حين يصل إشارة من جهاز التتبع.": "The car's live location isn't available — it will appear once the tracking device sends a signal.",
  "الموعد": "Scheduled time",
  "آخر تحديث للموقع: {t} · يتحدّث تلقائياً": "Location last updated: {t} · updates automatically",
  "مؤجل": "Post-dated",
  "تم الصرف": "Cleared",
  "مرتجع": "Bounced",
  "تم تأكيد الحجز": "Booking confirmed",
  "تم تعيين السائق": "Driver assigned",
  "السائق في الطريق إليك": "Driver is on the way to you",
  "السائق وصل وبانتظارك": "Driver has arrived and is waiting for you",
  "وصلت إلى الوجهة": "Arrived at destination",
  "اكتملت الرحلة": "Trip completed",
  "أُلغيت الرحلة": "Trip cancelled",
  "أُغلقت الرحلة": "Trip closed",
  "الرابط غير صالح": "Invalid link",
  "انتهت صلاحية رابط التتبّع — الرحلة مغلقة": "The tracking link has expired — the trip is closed",
};
export default EN_B9;
